import { Text } from '@react-email/components'
import { type ReactNode } from 'react'

export function InstructionsText({ children }: { children: ReactNode }) {
  const instructionsTextClass =
    'mt-[16px] text-center text-black-default font-normal tracking-[-0.04px]'

  const instructionsTextStyle = { fontSize: '18px' }

  return (
    <Text className={instructionsTextClass} style={instructionsTextStyle}>
      {children}
    </Text>
  )
}
